const ScenarioTypeEnum = {
  STRESSED: "stressato",
  FAVORABLE: "favorevole",
  MODERATE: "moderato",
  UNFAVORABLE: "sfavorevole"
};

export default Object.freeze(ScenarioTypeEnum);
